import { useState } from "react";
import ServerTable from "../../../components/atoms/tables/serverTable";
import { useLocation, useNavigate } from "react-router-dom";
const HistoryEmployee = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const uid = location.pathname.split("/").pop();
    const [filters, setFilters] = useState({
        employee: uid
    });
    const columns = [
        {
            name: "Attribute",
            selector: "recordDisplayName",
            sortable: true,
        },
        {
            name: "Value",
            selector: "recordValue",
        },
        {
            name: "Start Date",
            selector: "startDate",
            sortable: true,
            cell: (row) => {
                return new Date(row.startDate).toLocaleDateString();
            }
        },
        {
            name: "End Date",
            selector: "endDate",
            sortable: true,
            cell: (row) => {
                return new Date(row.endDate).toLocaleDateString();
            }
        }
    ];
    return (
        <div>
            <div >
                <button
                    onClick={() => {
                        navigate(`/employees/${uid}`);
                    }}
                    type="button" className="inline-flex items-center rounded border border-gray-300 bg-white ml-2 px-2.5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                    Back To Employee
                </button>

            </div>
            <div className='mt-4'>
                <ServerTable
                    key={JSON.stringify(filters)}
                    apiURL={'/employee/history/get'}
                    columns={columns}
                    filters={filters}
                />
            </div>
        </div>
    )
}
export default HistoryEmployee;